import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';

import { TeamSectionEnum } from '../enums';
import InternalRecruiterSection from '../InternalRecruiterSection';
import useQueryMatch from 'hooks/useQueryMatch';

const PAGE_SECTIONS = Object.values(TeamSectionEnum);

export default function TeamPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const query = queryString.parse(location.search);
  const pageSectionMatch = useQueryMatch(PAGE_SECTIONS);

  useEffect(() => {
    if (!pageSectionMatch) {
      navigate(`${location.pathname}?section=${TeamSectionEnum.Recruiters}`, {
        replace: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSectionMatch]);

  const getSection = () => {
    switch (query.section) {
      case TeamSectionEnum.Recruiters:
      default:
        return <InternalRecruiterSection />;
    }
  };

  return <div className="page-wrapper">{getSection()}</div>;
}
